import { render, staticRenderFns } from "./GrooveHelpModal.vue?vue&type=template&id=4daae60c&scoped=true"
import script from "./GrooveHelpModal.vue?vue&type=script&lang=js"
export * from "./GrooveHelpModal.vue?vue&type=script&lang=js"
import style0 from "./GrooveHelpModal.vue?vue&type=style&index=0&id=4daae60c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4daae60c",
  null
  
)

export default component.exports